var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcelLogo = function SvgExcelLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#185C37",
    d: "m120.529 95.858-62.6-11.163v82.484c0 3.767 3.022 6.821 6.75 6.821h108.018c3.728 0 6.75-3.054 6.75-6.821V136.79z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M120.529 25.16h-55.85c-3.728 0-6.75 3.053-6.75 6.82v30.39l62.6 37.21 33.141 11.163 25.777-11.163V62.37z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M57.929 62.37h62.6v37.21h-62.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M102.732 54.927H57.929v93.026h44.803c3.723-.013 6.738-3.059 6.75-6.821V61.747c-.012-3.761-3.027-6.808-6.75-6.82",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.05 58.648H57.929v93.026h41.12c3.723-.012 6.738-3.059 6.75-6.82V65.469c-.012-3.762-3.027-6.808-6.75-6.82",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.05 58.648H57.929v85.584h41.12c3.723-.012 6.738-3.059 6.75-6.82V65.469c-.012-3.762-3.027-6.808-6.75-6.82",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M95.367 58.648H57.93v85.584h37.438c3.723-.012 6.738-3.059 6.75-6.82V65.469c-.012-3.762-3.027-6.808-6.75-6.82",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M27.856 58.648H95.37c3.728 0 6.749 3.054 6.749 6.821v68.221c0 3.767-3.021 6.821-6.75 6.821H27.857c-3.728 0-6.75-3.054-6.75-6.821V65.47c0-3.768 3.022-6.822 6.75-6.822"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.013 121.749 14.199-22.233-13.01-22.11h10.465l7.1 14.14q.983 2.012 1.348 2.998h.092a56 56 0 0 1 1.473-3.122l7.59-14.01h9.606l-13.34 21.98 13.68 22.357H70.992l-8.2-15.521a13 13 0 0 1-.98-2.072h-.122a10 10 0 0 1-.95 2.009l-8.443 15.584z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#33C481",
    d: "M172.697 25.16h-52.168v37.21h58.918V31.98c0-3.767-3.022-6.82-6.75-6.82"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M120.529 99.58h58.918v37.21h-58.918z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 35.18,
    x2: 88.878,
    y1: 53.319,
    y2: 145.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
};
export { SvgExcelLogo as ReactComponent };
export default "/_next/static/chunks/svg/excel-logo-13182804db1476218677859bf1e3d936.svg";